/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const bottomWallItemWithDefaultToeKickComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'toeKick', true).withAlias('BottomWallItemWithDefaultToeKick').attach(memoEval((self)=>[
            self.$toeKickObjectName
        ], ($toeKickObjectName)=>({
            fileUrl: '/models/jms.glb',
            objectName: $toeKickObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'toeKick', true).withAlias('BottomWallItemWithDefaultToeKick').attach(memoEval((self)=>[
            self.$toeKickOffsetX,
            self.$toeKickOffsetZ,
            self.$toeKickWidth,
            self.$toeKickWidthScaleZero,
            self.$toeKickWidthScaleOne,
            self.$toeKickDepth,
            self.$toeKickDepthScaleZero,
            self.$toeKickDepthScaleOne
        ], ($toeKickOffsetX, $toeKickOffsetZ, $toeKickWidth, $toeKickWidthScaleZero, $toeKickWidthScaleOne, $toeKickDepth, $toeKickDepthScaleZero, $toeKickDepthScaleOne)=>({
            offsetX: $toeKickOffsetX,
            offsetZ: $toeKickOffsetZ,
            morphTargetInfluences: {
                Width: {
                    value: $toeKickWidth,
                    scaleZero: $toeKickWidthScaleZero,
                    scaleOne: $toeKickWidthScaleOne
                },
                Depth: {
                    value: $toeKickDepth,
                    scaleZero: $toeKickDepthScaleZero,
                    scaleOne: $toeKickDepthScaleOne
                }
            }
        })))
];

//# sourceMappingURL=bottom-wall-item-with-default-toe-kick.js.map